module.exports = __webpack_public_path__ + "img/bg.ca0cf72d.png";